

class NSSVideo extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.els = {
      videos: this.querySelectorAll(`video`),
    }
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Video] Connected.`);

    this.addEventListener(`click`, this.handleClick.bind(this));
  }

  handleClick(e) {
    if (this.debug) console.log(`[NSS][Video] Click!`);

    const status = this.getAttribute(`nss-video-playing`);
    if (this.debug) console.log(`[NSS][Video] status:`, status);
    if (status === "true") {
      this.setAttribute(`nss-video-playing`, false);
      this.els.videos.forEach((videoEl) => videoEl.pause());
    } else {
      this.setAttribute(`nss-video-playing`, true);
      this.els.videos.forEach((videoEl) => videoEl.play());
    }
  }
}

let elementName = `nss-video`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSVideo);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}